export default __webpack_public_path__ + "static/media/AGAXY.bcd58930.jpg";